import { render, staticRenderFns } from "./SanctionUpdate.vue?vue&type=template&id=0439598a"
import script from "./SanctionUpdate.vue?vue&type=script&lang=js"
export * from "./SanctionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports